import React, { useState, useEffect, useRef } from 'react';

// ── DATA ──────────────────────────────────────────────────────────────────────

const HOUSEHOLD_DATA = [
	{
		amount: 'Multiple',
		category: 'Spouse, Child(s), & Lodgers / Service',
		interpretation: 'Parent relocating with children and staff turnover',
		risk: 'Medium',
		households: 3,
		persons: 39,
		missing: 29,
		occupants: 48,
	},
	{
		amount: 'Multiple',
		category: 'Head & Lodgers / Service',
		interpretation: 'Employer relocation or staff turnover',
		risk: 'Low',
		households: 27,
		persons: 135,
		missing: 16,
		occupants: 26,
	},
	{
		amount: 'Multiple',
		category: 'Child(s) & Lodgers / Service',
		interpretation: 'Mixed household turnover and child relocation',
		risk: 'Low',
		households: 16,
		persons: 70,
		missing: 12,
		occupants: 19,
	},
	{
		amount: 'Multiple',
		category: 'Lodgers / Service Only',
		interpretation: 'Domestic worker turnover or boarding mobility',
		risk: 'Low',
		households: 120,
		persons: 289,
		missing: 10,
		occupants: 37,
	},
	{
		amount: 'Multiple',
		category: 'Spouse & Lodgers / Service',
		interpretation: 'Household restructuring with staff turnover',
		risk: 'Low',
		households: 22,
		persons: 85,
		missing: 10,
		occupants: 15,
	},
	{
		amount: 'Multiple',
		category: 'Entire Household',
		interpretation: 'Strong unexplained disappearance',
		risk: 'High',
		households: 44,
		persons: 126,
		missing: 9,
		occupants: 9,
	},
	{
		amount: 'Multiple',
		category: 'Head, Child(s), Lodgers / Service, & Other Family',
		interpretation: 'Large household disappearance',
		risk: 'High',
		households: 1,
		persons: 9,
		missing: 9,
		occupants: 14,
	},
	{
		amount: 'Multiple',
		category: 'Parents & Lodgers / Service',
		interpretation: 'Family relocation with household staff turnover',
		risk: 'Medium',
		households: 18,
		persons: 80,
		missing: 9,
		occupants: 13,
	},
	{
		amount: 'Multiple',
		category: 'Parents, Child(s), & Other Family',
		interpretation: 'Extended nuclear family relocation',
		risk: 'Medium',
		households: 1,
		persons: 7,
		missing: 7,
		occupants: 12,
	},
	{
		amount: 'Multiple',
		category: 'Spouse, Lodgers / Service, & Other Family',
		interpretation: 'Household restructuring with mixed dependents',
		risk: 'Low',
		households: 1,
		persons: 7,
		missing: 7,
		occupants: 9,
	},
	{
		amount: 'Multiple',
		category: 'Child(s) Only',
		interpretation:
			'Children leaving household for work, schooling, or marriage',
		risk: 'Medium',
		households: 30,
		persons: 78,
		missing: 6,
		occupants: 11,
	},
	{
		amount: 'Multiple',
		category: 'Head & Child(s)',
		interpretation: 'Household restructuring, possible relocation or widowhood',
		risk: 'Medium',
		households: 16,
		persons: 44,
		missing: 5,
		occupants: 10,
	},
	{
		amount: 'Multiple',
		category: 'Head & Other Family',
		interpretation: 'Household leadership relocation affecting relatives',
		risk: 'Medium',
		households: 16,
		persons: 43,
		missing: 5,
		occupants: 8,
	},
	{
		amount: 'Multiple',
		category: 'Head, Child(s), & Lodgers / Service',
		interpretation: 'Household relocation with dependents and staff',
		risk: 'Medium',
		households: 3,
		persons: 14,
		missing: 5,
		occupants: 9,
	},
	{
		amount: 'Multiple',
		category: 'Head, Lodgers / Service, & Other Family',
		interpretation: 'Household relocation affecting multiple dependents',
		risk: 'Medium',
		households: 4,
		persons: 14,
		missing: 5,
		occupants: 10,
	},
	{
		amount: 'Multiple',
		category: 'Parents & Child(s)',
		interpretation: 'Nuclear family relocation',
		risk: 'Medium',
		households: 10,
		persons: 36,
		missing: 5,
		occupants: 8,
	},
	{
		amount: 'Multiple',
		category: 'Parents, Lodgers / Service, & Other Family',
		interpretation: 'Large household restructuring',
		risk: 'Medium',
		households: 2,
		persons: 9,
		missing: 5,
		occupants: 6,
	},
	{
		amount: 'Multiple',
		category: 'Spouse, Child(s), Lodgers / Service, & Other Family',
		interpretation: 'Large mixed household disappearance',
		risk: 'High',
		households: 1,
		persons: 5,
		missing: 5,
		occupants: 8,
	},
	{
		amount: 'Multiple',
		category: 'Child(s), Lodgers / Service, & Other Family',
		interpretation: 'Mixed dependent turnover',
		risk: 'Low',
		households: 1,
		persons: 4,
		missing: 4,
		occupants: 8,
	},
	{
		amount: 'Multiple',
		category: 'Lodgers / Service & Other Family',
		interpretation: 'Boarding or domestic household turnover',
		risk: 'Low',
		households: 7,
		persons: 16,
		missing: 4,
		occupants: 11,
	},
	{
		amount: 'Multiple',
		category: 'Spouse & Child(s)',
		interpretation: 'Parent relocating with children',
		risk: 'Medium',
		households: 12,
		persons: 35,
		missing: 4,
		occupants: 12,
	},
	{
		amount: 'Multiple',
		category: 'Spouse, Child(s), & Other Family',
		interpretation: 'Family unit relocation including extended kin',
		risk: 'Medium',
		households: 2,
		persons: 7,
		missing: 4,
		occupants: 10,
	},
	{
		amount: 'Multiple',
		category: 'Child(s) & Other Family',
		interpretation:
			'Extended family restructuring or children leaving with relatives',
		risk: 'Medium',
		households: 4,
		persons: 10,
		missing: 3,
		occupants: 11,
	},
	{
		amount: 'Multiple',
		category: 'Head, Child(s), & Other Family',
		interpretation: 'Household leadership relocation affecting dependents',
		risk: 'Medium',
		households: 1,
		persons: 3,
		missing: 3,
		occupants: 11,
	},
	{
		amount: 'Multiple',
		category: 'Other Family Only',
		interpretation: 'Extended relatives moving to other households',
		risk: 'Low',
		households: 4,
		persons: 10,
		missing: 3,
		occupants: 6,
	},
	{
		amount: 'Multiple',
		category: 'Parents & Other Family',
		interpretation: 'Extended family relocation',
		risk: 'Medium',
		households: 2,
		persons: 6,
		missing: 3,
		occupants: 7,
	},
	{
		amount: 'Multiple',
		category: 'Spouse & Other Family',
		interpretation: 'Family restructuring or relocation with relatives',
		risk: 'Medium',
		households: 8,
		persons: 18,
		missing: 3,
		occupants: 9,
	},
	{
		amount: 'Multiple',
		category: 'Parents',
		interpretation: 'Married couple relocation',
		risk: 'Medium',
		households: 38,
		persons: 76,
		missing: 2,
		occupants: 14,
	},
	{
		amount: 'Single',
		category: 'Child(s) Only',
		interpretation:
			'Children leaving household for work, schooling, or marriage',
		risk: 'Medium',
		households: 45,
		persons: 45,
		missing: 1,
		occupants: 11,
	},
	{
		amount: 'Single',
		category: 'Entire Household',
		interpretation: 'Strong unexplained disappearance',
		risk: 'High',
		households: 3,
		persons: 3,
		missing: 1,
		occupants: 1,
	},
	{
		amount: 'Single',
		category: 'Head Only',
		interpretation: 'Primary earner disappearance or relocation',
		risk: 'Medium',
		households: 72,
		persons: 72,
		missing: 1,
		occupants: 9,
	},
	{
		amount: 'Single',
		category: 'Lodgers / Service Only',
		interpretation: 'Domestic worker turnover or boarding mobility',
		risk: 'Low',
		households: 275,
		persons: 275,
		missing: 1,
		occupants: 49,
	},
	{
		amount: 'Single',
		category: 'Other Family Only',
		interpretation: 'Extended relatives moving to other households',
		risk: 'Low',
		households: 19,
		persons: 19,
		missing: 1,
		occupants: 43,
	},
	{
		amount: 'Single',
		category: 'Spouse Only',
		interpretation: 'Marital separation, remarriage, or relocation',
		risk: 'Medium',
		households: 50,
		persons: 50,
		missing: 1,
		occupants: 10,
	},
];

const RISK_COLORS = {
	High: { color: '#E07070', bg: '#2A1818', border: '#3A2020', dim: '#8A4040' },
	Medium: {
		color: '#C88A50',
		bg: '#221A10',
		border: '#342410',
		dim: '#8A6030',
	},
	Low: { color: '#6DBF67', bg: '#0E1F0E', border: '#162A16', dim: '#3A7A36' },
};

function getRiskCounts() {
	const counts = {
		High: { hh: 0, persons: 0 },
		Medium: { hh: 0, persons: 0 },
		Low: { hh: 0, persons: 0 },
	};
	HOUSEHOLD_DATA.forEach((r) => {
		counts[r.risk].hh += r.households;
		counts[r.risk].persons += r.persons;
	});
	return counts;
}

// ── FUNNEL ────────────────────────────────────────────────────────────────────

function FunnelViz({ C, compact }) {
	const [animated, setAnimated] = useState(false);
	const ref = useRef(null);

	useEffect(() => {
		const observer = new IntersectionObserver(
			([entry]) => {
				if (entry.isIntersecting) setTimeout(() => setAnimated(true), 100);
			},
			{ threshold: 0.2 },
		);
		if (ref.current) observer.observe(ref.current);
		return () => observer.disconnect();
	}, []);

	const steps = [
		{
			label: '1920 Oklahoma Census',
			value: '1,777,939',
			pct: '100%',
			width: 100,
		},
		{ label: 'Black Oklahomans', value: '109,678', pct: '6.17%', width: 72 },
		{ label: 'Tulsa Urban Area', value: '56,999', pct: '3.21%', width: 52 },
		{ label: 'Prime Age (16–49)', value: '2,881', pct: '0.16%', width: 34 },
		{
			label: 'No Further Census Records',
			value: '2,102',
			pct: '0.12%',
			width: 22,
		},
		{
			label: 'Active Risk Pool',
			value: '1,739',
			pct: '',
			width: 14,
			highlight: true,
		},
	];

	return (
		<div ref={ref} style={{ padding: '0 0 60px' }}>
			<div style={{ marginBottom: 28 }}>
				<div
					style={{
						fontFamily: 'DM Mono',
						fontSize: 10,
						letterSpacing: '0.15em',
						textTransform: 'uppercase',
						color: C.tealLight,
						marginBottom: 10,
					}}
				>
					How CDM Builds the Risk Pool
				</div>
				<h2
					style={{
						fontFamily: 'Playfair Display',
						color: 'white',
						fontSize: compact ? 22 : 28,
						marginBottom: 8,
					}}
				>
					From 1.7 million records to 1,739 individuals.
				</h2>
				<p
					style={{
						fontSize: 13,
						color: '#4A6A66',
						maxWidth: 520,
						lineHeight: 1.7,
					}}
				>
					Five sequential filters reduce the starting population to a bounded
					risk pool where census linkage failure is statistically anomalous.
				</p>
			</div>
			<div style={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
				{steps.map((step, i) => {
					const isLast = i === steps.length - 1;
					return (
						<div
							key={step.label}
							style={{
								display: 'flex',
								alignItems: 'center',
								gap: compact ? 12 : 20,
							}}
						>
							<div
								style={{
									flex: 1,
									position: 'relative',
									height: compact ? 38 : 44,
								}}
							>
								<div
									style={{
										position: 'absolute',
										left: 0,
										top: 0,
										bottom: 0,
										width: animated ? `${step.width}%` : '0%',
										background: isLast ? C.teal : '#1A3230',
										border: isLast
											? `1px solid ${C.teal}`
											: '1px solid #1A2E2A',
										transition: `width 0.7s cubic-bezier(0.4,0,0.2,1) ${i * 120}ms`,
										display: 'flex',
										alignItems: 'center',
										paddingLeft: 14,
										overflow: 'hidden',
										whiteSpace: 'nowrap',
									}}
								>
									<span
										style={{
											fontFamily: 'DM Mono',
											fontSize: compact ? 10 : 11,
											color: isLast ? 'white' : '#4A7A70',
											letterSpacing: '0.06em',
										}}
									>
										{step.label}
									</span>
								</div>
							</div>
							<div
								style={{
									width: compact ? 80 : 110,
									textAlign: 'right',
									flexShrink: 0,
								}}
							>
								<div
									style={{
										fontFamily: 'Playfair Display',
										fontSize: compact ? 14 : 17,
										color: isLast ? C.tealLight : '#6A8A86',
										fontWeight: 600,
									}}
								>
									{step.value}
								</div>
								{step.pct && (
									<div
										style={{
											fontFamily: 'DM Mono',
											fontSize: 9,
											color: '#2A4A46',
											letterSpacing: '0.08em',
										}}
									>
										{step.pct}
									</div>
								)}
							</div>
						</div>
					);
				})}
			</div>
			<div
				style={{ marginTop: 16, display: 'flex', gap: 20, flexWrap: 'wrap' }}
			>
				{[
					{ dot: C.teal, label: 'Active risk pool (1,739)' },
					{ dot: '#1A3230', label: 'Filtered out' },
				].map(({ dot, label }) => (
					<div
						key={label}
						style={{ display: 'flex', alignItems: 'center', gap: 7 }}
					>
						<div
							style={{ width: 8, height: 8, background: dot, flexShrink: 0 }}
						/>
						<span
							style={{
								fontFamily: 'DM Mono',
								fontSize: 10,
								color: '#4A6A66',
								letterSpacing: '0.06em',
							}}
						>
							{label}
						</span>
					</div>
				))}
			</div>
		</div>
	);
}

// ── RISK DISTRIBUTION ─────────────────────────────────────────────────────────

function RiskDistributionChart({ C, compact }) {
	const counts = getRiskCounts();
	const totalHH = 878;
	const [hovered, setHovered] = useState(null);

	const bars = [
		{
			risk: 'High',
			...counts.High,
			label: 'Entire household absent',
			note: 'Strongest signal of violent disruption',
		},
		{
			risk: 'Medium',
			...counts.Medium,
			label: 'Partial household absent',
			note: 'Possible relocation or displacement',
		},
		{
			risk: 'Low',
			...counts.Low,
			label: 'Individual absence',
			note: 'Migration or record instability likely',
		},
	];

	return (
		<div style={{ padding: '0 0 60px' }}>
			<div
				style={{
					borderTop: '1px solid #1A2A28',
					paddingTop: 60,
					marginBottom: 28,
				}}
			>
				<div
					style={{
						fontFamily: 'DM Mono',
						fontSize: 10,
						letterSpacing: '0.15em',
						textTransform: 'uppercase',
						color: C.tealLight,
						marginBottom: 10,
					}}
				>
					Risk Distribution
				</div>
				<h2
					style={{
						fontFamily: 'Playfair Display',
						color: 'white',
						fontSize: compact ? 22 : 28,
						marginBottom: 8,
					}}
				>
					878 households. Three risk levels.
				</h2>
				<p
					style={{
						fontSize: 13,
						color: '#4A6A66',
						maxWidth: 520,
						lineHeight: 1.7,
					}}
				>
					Household disruption patterns are classified by the composition of
					absences, not by individual records.
				</p>
			</div>
			<div style={{ height: 52, display: 'flex', marginBottom: 24, gap: 2 }}>
				{bars.map(({ risk, hh }) => {
					const pct = (hh / totalHH) * 100;
					const rc = RISK_COLORS[risk];
					const isHov = hovered === risk;
					return (
						<div
							key={risk}
							onMouseEnter={() => setHovered(risk)}
							onMouseLeave={() => setHovered(null)}
							style={{
								width: `${pct}%`,
								background: isHov ? rc.color : rc.bg,
								border: `1px solid ${isHov ? rc.color : rc.border}`,
								transition: 'background 0.2s, border 0.2s',
								cursor: 'default',
								display: 'flex',
								alignItems: 'center',
								justifyContent: 'center',
							}}
						>
							{pct > 12 && (
								<span
									style={{
										fontFamily: 'DM Mono',
										fontSize: 10,
										color: isHov ? 'white' : rc.dim,
										letterSpacing: '0.08em',
									}}
								>
									{Math.round(pct)}%
								</span>
							)}
						</div>
					);
				})}
			</div>
			<div style={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
				{bars.map(({ risk, hh, persons, label, note }) => {
					const rc = RISK_COLORS[risk];
					const pct = ((hh / totalHH) * 100).toFixed(1);
					const isHov = hovered === risk;
					return (
						<div
							key={risk}
							onMouseEnter={() => setHovered(risk)}
							onMouseLeave={() => setHovered(null)}
							style={{
								background: isHov ? rc.bg : '#0D1816',
								border: `1px solid ${isHov ? rc.border : '#1A2E2A'}`,
								borderLeft: `3px solid ${rc.color}`,
								padding: compact ? '16px 18px' : '18px 24px',
								display: 'flex',
								flexDirection: compact ? 'column' : 'row',
								alignItems: compact ? 'flex-start' : 'center',
								gap: compact ? 8 : 0,
								transition: 'background 0.2s, border 0.2s',
								cursor: 'default',
							}}
						>
							<div style={{ flex: 1 }}>
								<div
									style={{
										display: 'flex',
										alignItems: 'center',
										gap: 10,
										marginBottom: 4,
									}}
								>
									<span
										style={{
											fontFamily: 'DM Mono',
											fontSize: 10,
											color: rc.color,
											letterSpacing: '0.12em',
											textTransform: 'uppercase',
											fontWeight: 600,
										}}
									>
										{risk}
									</span>
									<span
										style={{ fontSize: 13, color: '#A0B0AE', fontWeight: 500 }}
									>
										{label}
									</span>
								</div>
								<div style={{ fontSize: 12, color: '#4A6A66' }}>{note}</div>
							</div>
							<div
								style={{
									display: 'flex',
									gap: compact ? 24 : 40,
									flexShrink: 0,
								}}
							>
								{[
									{ val: hh, color: rc.color, lbl: 'HOUSEHOLDS' },
									{ val: persons, color: '#6A8A86', lbl: 'PERSONS' },
									{ val: `${pct}%`, color: '#4A6A66', lbl: 'OF POOL' },
								].map(({ val, color, lbl }) => (
									<div key={lbl} style={{ textAlign: 'right' }}>
										<div
											style={{
												fontFamily: 'Playfair Display',
												fontSize: 20,
												color,
											}}
										>
											{val}
										</div>
										<div
											style={{
												fontFamily: 'DM Mono',
												fontSize: 9,
												color: '#2A4A46',
												letterSpacing: '0.08em',
											}}
										>
											{lbl}
										</div>
									</div>
								))}
							</div>
						</div>
					);
				})}
			</div>
		</div>
	);
}

// ── HOUSEHOLD COMPOSITION EXPLORER ───────────────────────────────────────────

function HouseholdCompositionExplorer({ C, compact }) {
	const [activeFilter, setActiveFilter] = useState('All');
	const [sortBy, setSortBy] = useState('households');
	const [expanded, setExpanded] = useState(null);

	const filterOptions = ['All', 'High', 'Medium', 'Low'];
	const filtered = HOUSEHOLD_DATA.filter(
		(r) => activeFilter === 'All' || r.risk === activeFilter,
	).sort((a, b) => b[sortBy] - a[sortBy]);
	const totalFiltered = filtered.reduce(
		(acc, r) => ({
			hh: acc.hh + r.households,
			persons: acc.persons + r.persons,
		}),
		{ hh: 0, persons: 0 },
	);

	return (
		<div style={{ padding: '0 0 60px' }}>
			<div
				style={{
					borderTop: '1px solid #1A2A28',
					paddingTop: 60,
					marginBottom: 28,
				}}
			>
				<div
					style={{
						fontFamily: 'DM Mono',
						fontSize: 10,
						letterSpacing: '0.15em',
						textTransform: 'uppercase',
						color: C.tealLight,
						marginBottom: 10,
					}}
				>
					Household Composition
				</div>
				<h2
					style={{
						fontFamily: 'Playfair Display',
						color: 'white',
						fontSize: compact ? 22 : 28,
						marginBottom: 8,
					}}
				>
					Who disappeared, and how.
				</h2>
				<p
					style={{
						fontSize: 13,
						color: '#4A6A66',
						maxWidth: 520,
						lineHeight: 1.7,
					}}
				>
					Each category describes which household members failed to link
					forward. The pattern of absence, not just the absence itself, is the
					signal.
				</p>
			</div>
			<div
				style={{
					display: 'flex',
					flexDirection: compact ? 'column' : 'row',
					gap: 12,
					marginBottom: 16,
					alignItems: compact ? 'flex-start' : 'center',
					justifyContent: 'space-between',
				}}
			>
				<div style={{ display: 'flex', gap: 2 }}>
					{filterOptions.map((f) => {
						const rc = f === 'All' ? null : RISK_COLORS[f];
						const isActive = activeFilter === f;
						return (
							<button
								key={f}
								onClick={() => setActiveFilter(f)}
								style={{
									padding: '8px 16px',
									border: `1px solid ${isActive ? (rc ? rc.color : C.teal) : '#1A2E2A'}`,
									background: isActive
										? rc
											? rc.bg
											: '#162220'
										: 'transparent',
									color: isActive ? (rc ? rc.color : C.tealLight) : '#4A6A66',
									fontFamily: 'DM Mono',
									fontSize: 10,
									letterSpacing: '0.1em',
									textTransform: 'uppercase',
									cursor: 'pointer',
									transition: 'all 0.15s',
								}}
							>
								{f}
							</button>
						);
					})}
				</div>
				<div style={{ display: 'flex', gap: 2, alignItems: 'center' }}>
					<span
						style={{
							fontFamily: 'DM Mono',
							fontSize: 9,
							color: '#2A4A46',
							letterSpacing: '0.1em',
							marginRight: 6,
						}}
					>
						SORT BY
					</span>
					{[
						['households', 'Households'],
						['persons', 'Persons'],
						['missing', 'Missing'],
					].map(([val, lbl]) => (
						<button
							key={val}
							onClick={() => setSortBy(val)}
							style={{
								padding: '7px 12px',
								border: `1px solid ${sortBy === val ? C.teal : '#1A2E2A'}`,
								background: sortBy === val ? '#162220' : 'transparent',
								color: sortBy === val ? C.tealLight : '#4A6A66',
								fontFamily: 'DM Mono',
								fontSize: 9,
								letterSpacing: '0.08em',
								textTransform: 'uppercase',
								cursor: 'pointer',
								transition: 'all 0.15s',
							}}
						>
							{lbl}
						</button>
					))}
				</div>
			</div>
			<div
				style={{
					background: '#111E1C',
					border: '1px solid #1A2E2A',
					padding: '12px 20px',
					marginBottom: 2,
					display: 'flex',
					gap: 32,
					alignItems: 'center',
				}}
			>
				<span
					style={{
						fontFamily: 'DM Mono',
						fontSize: 9,
						color: '#2A4A46',
						letterSpacing: '0.1em',
						textTransform: 'uppercase',
						flex: 1,
					}}
				>
					Showing {filtered.length} categories
				</span>
				<span style={{ fontFamily: 'DM Mono', fontSize: 10, color: '#4A6A66' }}>
					{totalFiltered.hh} households
				</span>
				<span style={{ fontFamily: 'DM Mono', fontSize: 10, color: '#4A6A66' }}>
					{totalFiltered.persons} persons
				</span>
			</div>
			<div
				style={{
					display: 'flex',
					flexDirection: 'column',
					gap: 1,
					maxHeight: 480,
					overflowY: 'auto',
				}}
			>
				{filtered.map((row, i) => {
					const rc = RISK_COLORS[row.risk];
					const isExp = expanded === i;
					const maxHH = Math.max(...filtered.map((r) => r.households));
					return (
						<div
							key={i}
							onClick={() => setExpanded(isExp ? null : i)}
							style={{
								background: isExp ? rc.bg : '#0D1816',
								border: `1px solid ${isExp ? rc.border : '#1A2E2A'}`,
								borderLeft: `3px solid ${rc.color}`,
								padding: compact ? '12px 14px' : '13px 20px',
								cursor: 'pointer',
								transition: 'background 0.15s, border 0.15s',
							}}
						>
							<div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
								<div
									style={{
										width: 6,
										height: 6,
										borderRadius: '50%',
										background: rc.color,
										flexShrink: 0,
									}}
								/>
								<div style={{ flex: 1, minWidth: 0 }}>
									<div
										style={{
											fontSize: compact ? 11 : 13,
											color: '#A0B0AE',
											fontWeight: 500,
											whiteSpace: compact ? 'normal' : 'nowrap',
											overflow: 'hidden',
											textOverflow: 'ellipsis',
										}}
									>
										{row.amount === 'Single' ? '(Single) ' : ''}
										{row.category}
									</div>
									{isExp && (
										<div
											style={{
												fontSize: 12,
												color: '#6A8A86',
												marginTop: 6,
												lineHeight: 1.6,
											}}
										>
											{row.interpretation}
										</div>
									)}
								</div>
								{!compact && (
									<div
										style={{
											width: 120,
											height: 4,
											background: '#1A2E2A',
											flexShrink: 0,
											position: 'relative',
										}}
									>
										<div
											style={{
												position: 'absolute',
												left: 0,
												top: 0,
												bottom: 0,
												width: `${(row.households / maxHH) * 100}%`,
												background: rc.color,
												opacity: 0.6,
											}}
										/>
									</div>
								)}
								<div
									style={{
										display: 'flex',
										gap: compact ? 16 : 28,
										flexShrink: 0,
										textAlign: 'right',
									}}
								>
									{[
										{ val: row.households, color: rc.color, lbl: 'HH' },
										{ val: row.persons, color: '#6A8A86', lbl: 'PERSONS' },
									].map(({ val, color, lbl }) => (
										<div key={lbl}>
											<div
												style={{
													fontFamily: 'Playfair Display',
													fontSize: compact ? 14 : 16,
													color,
												}}
											>
												{val}
											</div>
											<div
												style={{
													fontFamily: 'DM Mono',
													fontSize: 8,
													color: '#2A4A46',
													letterSpacing: '0.06em',
												}}
											>
												{lbl}
											</div>
										</div>
									))}
								</div>
								<div
									style={{
										color: '#2A4A46',
										fontSize: 12,
										marginLeft: 4,
										flexShrink: 0,
									}}
								>
									{isExp ? '▲' : '▼'}
								</div>
							</div>
						</div>
					);
				})}
			</div>
		</div>
	);
}

// ── MAIN PAGE ─────────────────────────────────────────────────────────────────

function ExploreDataPage({ C, useBreakpoint, Link }) {
	const { isMobile, isTablet, px } = useBreakpoint();
	const compact = isMobile || isTablet;

	const stats = [
		{ label: 'Total Households', value: '878', sub: 'in risk pool' },
		{
			label: 'Active Risk Pool',
			value: '1,739',
			sub: 'no forward census link',
		},
		{
			label: 'Confirmed Survivors',
			value: '363',
			sub: 'verified via external records',
		},
		{ label: 'No Archival Trace', value: '735', sub: 'hardest to research' },
	];

	return (
		<div style={{ paddingTop: 100 }}>
			{/* ── HEADER ── */}
			<div style={{ padding: `60px ${px} 48px` }}>
				<div className='section-label fade-up' style={{ marginBottom: 20 }}>
					Explore Data
				</div>
				<h1
					className='display-heading fade-up delay-1'
					style={{
						fontSize: compact ? 'clamp(30px,7vw,52px)' : 'clamp(38px,5vw,60px)',
						marginBottom: 14,
					}}
				>
					The risk pool.
				</h1>
				<p
					style={{
						fontSize: compact ? 14 : 16,
						color: '#8AACAA',
						maxWidth: 580,
						lineHeight: 1.9,
					}}
				>
					These are statistical signals — anomalous absences in the historical
					record that warrant further investigation. They are research leads,
					not confirmed victims.
				</p>
			</div>

			{/* ── STAT CARDS ── */}
			<div
				style={{
					padding: `0 ${px} 48px`,
					display: 'grid',
					gridTemplateColumns: isMobile ? '1fr 1fr' : 'repeat(4,1fr)',
					gap: 2,
				}}
			>
				{stats.map(({ label, value, sub }, i) => (
					<div
						key={label}
						style={{
							background:
								i === 0
									? C.teal
									: i === 1
										? '#162220'
										: i === 2
											? '#111E1C'
											: '#0D1816',
							border: '1px solid #1A2E2A',
							padding: compact ? '24px 18px' : '36px 28px',
							position: 'relative',
							overflow: 'hidden',
						}}
					>
						<div
							style={{
								position: 'absolute',
								top: 0,
								left: 0,
								right: 0,
								height: 2,
								background: i === 0 ? 'rgba(255,255,255,0.2)' : C.teal,
								opacity: i === 0 ? 1 : 0.4,
							}}
						/>
						<div
							className='stat-number'
							style={{
								fontSize: compact ? 34 : 48,
								marginBottom: 10,
								color: i === 0 ? 'white' : C.tealLight,
							}}
						>
							{value}
						</div>
						<div
							style={{
								fontWeight: 500,
								fontSize: 13,
								marginBottom: 4,
								color: i === 0 ? 'rgba(255,255,255,0.9)' : '#A0B0AE',
							}}
						>
							{label}
						</div>
						<div
							style={{
								fontSize: 10,
								color: i === 0 ? 'rgba(255,255,255,0.5)' : '#4A6A66',
								fontFamily: 'DM Mono',
								letterSpacing: '0.08em',
							}}
						>
							{sub}
						</div>
					</div>
				))}
			</div>

			{/* ── DATA NOTE ── */}
			<div style={{ padding: `0 ${px}`, marginBottom: 48 }}>
				<div
					style={{
						background: '#111E1C',
						border: '1px solid #1A2E2A',
						borderLeft: `3px solid ${C.teal}`,
						padding: '16px 20px',
						display: 'flex',
						gap: 16,
						alignItems: 'flex-start',
					}}
				>
					<div
						style={{
							fontFamily: 'DM Mono',
							fontSize: 9,
							color: C.tealLight,
							letterSpacing: '0.12em',
							textTransform: 'uppercase',
							whiteSpace: 'nowrap',
							paddingTop: 2,
						}}
					>
						Note
					</div>
					<p
						style={{
							fontSize: 13,
							color: '#6A8A86',
							lineHeight: 1.7,
							margin: 0,
						}}
					>
						Figures reflect the current state of manual review. 363 confirmed
						survivors (17.3%) have been verified via external records and
						removed from the active risk pool. The 735 individuals with no
						archival trace are not higher risk — they are harder to research.
						All 1,739 remaining persons represent equal statistical signals of
						disruption.
					</p>
				</div>
			</div>

			{/* ── FUNNEL ── */}
			<div style={{ padding: `0 ${px}` }}>
				<FunnelViz C={C} compact={compact} />
			</div>

			{/* ── RISK DISTRIBUTION ── */}
			<div style={{ padding: `0 ${px}` }}>
				<RiskDistributionChart C={C} compact={compact} />
			</div>

			{/* ── HOUSEHOLD COMPOSITION EXPLORER ── */}
			<div style={{ padding: `0 ${px}` }}>
				<HouseholdCompositionExplorer C={C} compact={compact} />
			</div>

			{/* ── 735 COHORT ── */}
			<div style={{ padding: `0 ${px}`, marginBottom: 60 }}>
				<div
					style={{
						display: 'grid',
						gridTemplateColumns: isMobile ? '1fr' : '1fr 1fr',
						gap: 2,
					}}
				>
					<div
						style={{
							background: '#111E1C',
							border: '1px solid #1A2E2A',
							padding: compact ? '28px 24px' : '36px 32px',
						}}
					>
						<div
							style={{
								fontFamily: 'DM Mono',
								fontSize: 10,
								letterSpacing: '0.14em',
								textTransform: 'uppercase',
								color: C.tealLight,
								marginBottom: 16,
							}}
						>
							The 735 · No Archival Trace
						</div>
						<p
							style={{
								fontSize: compact ? 14 : 15,
								color: '#8AACAA',
								lineHeight: 1.9,
								marginBottom: 20,
							}}
						>
							These individuals have no records beyond the 1920 census — no
							death certificates, no migration trail, no later enumeration. They
							are not more likely to be victims than others in the risk pool.
							But they are the hardest to reach.
						</p>
						<p
							style={{
								fontSize: compact ? 14 : 15,
								color: '#6A8A86',
								lineHeight: 1.9,
								margin: 0,
							}}
						>
							A name may exist in a family archive, a church roll, a
							descendant's memory. The data has done what data can do. What
							comes next is human.
						</p>
					</div>
					<div
						style={{
							background: '#0D1816',
							border: '1px solid #1A2E2A',
							padding: compact ? '28px 24px' : '36px 32px',
							display: 'flex',
							flexDirection: 'column',
							gap: 16,
						}}
					>
						<div
							style={{
								fontFamily: 'DM Mono',
								fontSize: 10,
								letterSpacing: '0.14em',
								textTransform: 'uppercase',
								color: C.tealLight,
								marginBottom: 4,
							}}
						>
							What Each Profile Contains
						</div>
						{[
							['Age & sex', 'At time of 1920 enumeration'],
							['Household role', 'Head, spouse, child, lodger, etc.'],
							['Marital status', 'Including spouse-absent indicators'],
							['Occupational class', 'Economic standing in Greenwood'],
							['Disruption pattern', 'Risk-classified household composition'],
							['Enumeration district', 'Precise geographic location, 1920'],
						].map(([label, detail]) => (
							<div
								key={label}
								style={{
									display: 'flex',
									gap: 12,
									alignItems: 'flex-start',
									paddingBottom: 14,
									borderBottom: '1px solid #1A2E2A',
								}}
							>
								<span
									style={{
										color: C.teal,
										fontSize: 7,
										flexShrink: 0,
										marginTop: 5,
									}}
								>
									◆
								</span>
								<div>
									<div
										style={{
											fontSize: 13,
											color: '#A0B0AE',
											fontWeight: 500,
											marginBottom: 2,
										}}
									>
										{label}
									</div>
									<div
										style={{
											fontSize: 11,
											color: '#4A6A66',
											fontFamily: 'DM Mono',
											letterSpacing: '0.06em',
										}}
									>
										{detail}
									</div>
								</div>
							</div>
						))}
					</div>
				</div>
				<div
					style={{
						marginTop: 2,
						background: '#070F0D',
						border: '1px solid #1A2E2A',
						borderLeft: '3px solid #E07070',
						padding: compact ? '20px 24px' : '24px 32px',
					}}
				>
					<p
						style={{
							fontFamily: 'Playfair Display',
							fontStyle: 'italic',
							fontSize: compact ? 15 : 17,
							color: '#A0B0AE',
							lineHeight: 1.7,
							margin: 0,
						}}
					>
						"In some ways the 735 is the most honest part of the model. These
						are people the historical record tried hardest to erase. No death
						certificate. No migration trail. No later enumeration. That is not a
						research gap — that is evidence of something."
					</p>
				</div>
			</div>

			{/* ── HEATMAP CTA ── */}
			<div style={{ padding: `0 ${px} 48px` }}>
				<div
					style={{
						background: '#070F0D',
						border: '1px solid #1A2E2A',
						padding: compact ? '32px 24px' : '48px',
						display: 'flex',
						flexDirection: compact ? 'column' : 'row',
						justifyContent: 'space-between',
						alignItems: compact ? 'flex-start' : 'center',
						gap: 28,
						position: 'relative',
						overflow: 'hidden',
					}}
				>
					<div
						style={{
							position: 'absolute',
							right: -60,
							top: -60,
							width: 200,
							height: 200,
							borderRadius: '50%',
							background: `${C.teal}08`,
							pointerEvents: 'none',
						}}
					/>
					<div style={{ position: 'relative', zIndex: 1 }}>
						<div
							style={{
								fontFamily: 'DM Mono',
								fontSize: 10,
								letterSpacing: '0.15em',
								textTransform: 'uppercase',
								color: C.tealLight,
								marginBottom: 12,
							}}
						>
							Interactive Map
						</div>
						<h3
							style={{
								fontFamily: 'Playfair Display',
								color: 'white',
								fontSize: compact ? 20 : 26,
								marginBottom: 8,
							}}
						>
							Greenwood District Disruption Heatmap
						</h3>
						<p
							style={{
								fontSize: 13,
								color: '#4A6A66',
								lineHeight: 1.7,
								maxWidth: 420,
							}}
						>
							Street-level visualization of census linkage failures across the
							Greenwood District and surrounding Tulsa urban area.
						</p>
					</div>
					<Link
						to='/heatmap'
						className='btn-primary'
						style={{ flexShrink: 0, position: 'relative', zIndex: 1 }}
					>
						View Heatmap →
					</Link>
				</div>
			</div>

			{/* ── DATABASE CTA — temporarily offline ── */}
			<div style={{ padding: `0 ${px} 80px` }} id='request'>
				<div
					style={{
						background: '#070F0D',
						border: '1px solid #1A2E2A',
						borderTop: `3px solid ${C.teal}`,
						padding: compact ? '32px 24px' : '48px',
						position: 'relative',
						overflow: 'hidden',
					}}
				>
					<div
						style={{
							position: 'absolute',
							left: -60,
							bottom: -60,
							width: 240,
							height: 240,
							borderRadius: '50%',
							background: `${C.teal}06`,
							pointerEvents: 'none',
						}}
					/>
					<div
						style={{
							position: 'relative',
							zIndex: 1,
							display: 'flex',
							flexDirection: compact ? 'column' : 'row',
							justifyContent: 'space-between',
							alignItems: compact ? 'flex-start' : 'center',
							gap: 28,
						}}
					>
						<div>
							<div
								style={{
									fontFamily: 'DM Mono',
									fontSize: 10,
									letterSpacing: '0.15em',
									textTransform: 'uppercase',
									color: C.tealLight,
									marginBottom: 12,
								}}
							>
								Individual Records
							</div>
							<h3
								style={{
									fontFamily: 'Playfair Display',
									color: 'white',
									fontSize: compact ? 20 : 26,
									marginBottom: 8,
								}}
							>
								Record browser temporarily offline.
							</h3>
							<p
								style={{
									fontSize: 13,
									color: '#4A6A66',
									lineHeight: 1.7,
									maxWidth: 460,
									margin: 0,
								}}
							>
								Individual records are temporarily unavailable while we complete
								a data licensing review. Summary statistics, the heatmap, and
								full methodology remain accessible. Records will return in a
								fully compliant form.
							</p>
						</div>
						<a
							href='mailto:thecenterfortheuncounted@censusdisruption.org?subject=Data Access Inquiry'
							style={{
								flexShrink: 0,
								background: 'transparent',
								border: `1px solid ${C.teal}`,
								cursor: 'pointer',
								padding: '13px 27px',
								color: C.tealLight,
								fontSize: 12,
								fontFamily: 'DM Mono',
								letterSpacing: '0.1em',
								textTransform: 'uppercase',
								whiteSpace: 'nowrap',
								textDecoration: 'none',
							}}
						>
							Get in Touch →
						</a>
					</div>
				</div>
			</div>
		</div>
	);
}

export default ExploreDataPage;
